import React from 'react';
import { CsrInlineError } from './CsrStatus';
import { DASH, fmt } from './csrFormat';

// Searchable, paged "register" from the design, shared by the Soil tests and Farmers tabs:
// title, search box, grid table with clickable rows, and Previous/Next pager.

export const listCount = (list) => {
  if (list.status === 'success') return fmt(list.total);
  return list.status === 'loading' ? '…' : DASH;
};

export const CsrPager = ({ page, limit, total, onPage, disabled }) => {
  const pages = Math.max(1, Math.ceil(total / limit));
  const from = total ? (page - 1) * limit + 1 : 0;
  const to = Math.min(total, page * limit);
  return (
    <div className="csr-pager">
      <span>{total ? `Showing ${fmt(from)}–${fmt(to)} of ${fmt(total)} · page ${fmt(page)} of ${fmt(pages)}` : ''}</span>
      <div className="csr-pager__buttons">
        <button type="button" className="csr-btn csr-btn--ghost" onClick={() => onPage(page - 1)} disabled={disabled || page <= 1}>← Previous</button>
        <button type="button" className="csr-btn csr-btn--ghost" onClick={() => onPage(page + 1)} disabled={disabled || page >= pages}>Next →</button>
      </div>
    </div>
  );
};

const CsrRegister = ({ id, title, subtitle, placeholder, list, columns, rowKey, rowLabel, onRowClick, emptyText = 'No records match this search.', skeletonRows = 6 }) => {
  const template = columns.map((c) => c.width).join(' ');
  const loading = list.status === 'loading';

  return (
    <section aria-labelledby={`${id}-h`} className="csr-card csr-register-panel">
      <div className="csr-register-panel__head">
        <div className="d-flex flex-column" style={{ gap: 2 }}>
          <h2 id={`${id}-h`}>{title}</h2>
          <p className="csr-panel__hint">{subtitle}</p>
        </div>
        <div className="csr-search">
          <label htmlFor={`${id}-q`}>Search</label>
          <input id={`${id}-q`} type="search" value={list.search} onChange={(e) => list.setSearch(e.target.value)} placeholder={placeholder} autoComplete="off" />
        </div>
      </div>

      {list.status === 'error' ? <CsrInlineError message={list.error} onRetry={list.retry} /> : (
        <>
          <div className="csr-register" aria-busy={loading}>
            <div className="csr-register__inner">
              <div className="csr-register__head" style={{ gridTemplateColumns: template }}>
                {columns.map((c) => <span key={c.key}>{c.label}</span>)}
              </div>
              {loading && list.rows.length === 0
                ? Array.from({ length: skeletonRows }).map((_, i) => <div key={i} className="csr-skel csr-register__skel" />)
                : list.rows.map((row) => (
                  <button
                    key={rowKey(row)}
                    type="button"
                    className={`csr-register__row ${loading ? 'is-stale' : ''}`}
                    style={{ gridTemplateColumns: template }}
                    onClick={() => onRowClick(row)}
                    aria-label={rowLabel ? rowLabel(row) : undefined}
                  >
                    {columns.map((c) => (
                      <span key={c.key} className={c.className}>{c.render ? c.render(row) : row[c.key]}</span>
                    ))}
                  </button>
                ))}
              {!loading && list.rows.length === 0 ? <p className="csr-register__empty">{emptyText}</p> : null}
            </div>
          </div>
          <CsrPager page={list.page} limit={list.limit} total={list.total} onPage={list.setPage} disabled={loading} />
        </>
      )}
    </section>
  );
};

export default CsrRegister;
